<template>
<div style="display: flex; flex-direction: column; height: 100vh;" id="mainFrame">
  <v-row v-if="loadingProgress == 100">
    <v-col>
       <h1>Prozessobjekte</h1>
    </v-col>
    <v-col class="text-right" style="align-self: center">
      <v-btn color="primary" elevation="0">
        <v-icon color="#F5F5F5" large @click="openContextItemDialog()">add</v-icon >
      </v-btn>
    </v-col>
  </v-row>
  <v-tabs left fixed-tabs v-model="tab" color="secondary" v-if="loadingProgress == 100">
      <v-tab id="tab" key="departments">Abteilungen
        <v-spacer/>
      </v-tab>
      <v-tab id="tab" key="systems">Systeme 
        <v-spacer/>
      </v-tab>
      <v-tab id="tab" key="roles">Rollen
        <v-spacer/>
      </v-tab>
    </v-tabs>
  <div style="flex: 1 1 auto; overflow-y: auto; height:100%;" >
    <v-data-table
            dense
            :headers="headers[objectProp]"
            :items="contextItems[objectProp]"
            :items-per-page="15"
            sort-by="createdDate"
            :sort-desc="true"
        >
          <template v-slot:body="{items}">
            <tbody>
            <tr v-for="item in items"
                :key="item.id"
                @mouseover="selectItem(item)"
                @mouseleave="unSelectItem(item)">
              <td>
                <v-tooltip v-if="item.description" bottom>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">{{item.friendlyName}}</span>
                    </template>
                    {{ item.description }}
                </v-tooltip>
                <span v-else>{{ item.friendlyName }}</span>
              </td>
              <td v-if="objectProp == 'department'">
                <v-avatar
                    :color="item.color ? item.color : 'gray'"
                    size="32"
                    style="color: #fff;"
                ></v-avatar>
              </td>
              <td v-else>
                {{ item.description }}
              </td>
              <td style="max-width: 80px;">
                <div v-if="item === selectedItem" class="d-flex">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="gray" small text @click="editConnectedRessource(item)" v-bind="attrs" v-on="on"><v-icon>mdi-pencil</v-icon> </v-btn>
                    </template>
                    <span>Bearbeiten</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="!item.connected">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="gray" small text @click="removeConnectedRessource(item)" v-bind="attrs"
                              v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                    <span>Löschen</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
            </tbody>
          </template>
        </v-data-table>
  </div>

<v-progress-linear
    style="position: absolute; bottom: 0;"
    color="primary accent-4"
    :indeterminate="loadingProgress == 100 ? false : true"
    height="5"
    :value="loadingProgress"
  ></v-progress-linear>
    <ConnectedRessourceDialog ref="ressourceDialog"/>
    <ConfirmDialog ref="confirmDialog" />
</div>
</template>

<script>
import DataTable from '@/components/common/DataTable.vue';
import connectedRessourceService from '@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/connectedRessourceService.js'
import ConnectedRessourceDialog from '@/pages/ProcessModeling/CustomModelingTools/ConnectedRessources/ConnectedRessourceDialog.vue';
import ConfirmDialog from "@/components/common/ConfirmDialog";
export default {
  components: { 
    DataTable,
    ConnectedRessourceDialog,
    ConfirmDialog
  },
  name: "ProcessMap",
  data() {
    return {
      characteristics: [],
      processMaps: [],
      noEditor: "No current editor",
      loadingProgress: 0,
      selectedItem: null,
      headers: {
          department: [
            {
              text: 'Name der Abteilung',
              align: 'start',
              value: 'name',
            },
            { text: 'Farbe', value: 'color' },
            { text: 'Aktionen', value: 'aktionen'}
          ],
          system: [
            {
              text: 'Name des Systems',
              align: 'start',
              value: 'name',
            },
            { text: 'Beschreibung', value: 'description' },
            { text: 'Aktionen', value: 'actions'}
          ],
          role: [
            {
              text: 'Name der Rolle',
              align: 'start',
              value: 'name',
            },
            { text: 'Beschreibung', value: 'description' },
            { text: 'Aktionen', value: 'aktionen'}  
          ]
          
      },
      contextItems: {
        department: [],
        system: [],
        role: []
      },
      tab: 0
    };
  },
  computed:{
    userId(){
      return this.$store.state.user.username;
    },
    tableItems(){
      return this.processMaps;
    },
    objectProp(){
        switch(this.tab){
            case 0: return "department";
            case 1: return "system";
            case 2: return "role";
        }
    }
  },
  mounted() {
    this.retrieveContextItems();
    // Set Table Header Max-Width
    let ths = document.querySelectorAll('th>span');
    for (let elem of ths) {
      if (elem.innerHTML.length > 18) {
        elem.parentElement.setAttribute("style", "display:flex;");
        elem.setAttribute("style", "display:flex;max-width:4rem;justify-content:center;align-items:center;");
      }
    }
  },
  methods: {
    async retrieveContextItems(){
        this.loadingProgress = 0;
        let res = await connectedRessourceService.retrieveConnectedRessources();
        this.contextItems.department = res.data.filter(elem => elem.type == "DEPARTMENT");
        this.contextItems.system = res.data.filter(elem => elem.type == "SYSTEM");
        this.contextItems.role = res.data.filter(elem => elem.type == "ROLE");
        this.loadingProgress = 100;
    },
    openContextItemDialog(){
    this.$refs.ressourceDialog
      .open(this.objectProp.toUpperCase(), true, true)
      .then(() => this.retrieveContextItems());
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem(item) {
      this.selectedItem = false;
    },
    previewCharacteristic(item){
      this.$refs.newCharacteristics.open(item.toUpperCase(), true).then(res =>{})
    },
    openProcessMap(){
      this.$router.push({name: 'processMap'});
    },
    deleteProcessCharacteristic(id){
      processMapService.deleteCharacteristic(id).then(() => this.retrieveProcessMaps());
    },
    editConnectedRessource(item){
      this.$refs.ressourceDialog
      .openDialogInEditMode(item)
      .then(res => this.retrieveContextItems())
    },
    removeConnectedRessource(item){
      this.$refs.confirmDialog
      .open(
        "Objekt löschen",
        "Wollen Sie das Objekt "+item.name+" wirklich löschen?"
      )
      .then(() => {
        connectedRessourceService.deleteConnectedRessource(item.id).then(res => {
          this.retrieveContextItems();
        })
      })
      .catch()
      
    }
  }
};
</script>
<style scoped>
.white{
  color: var(--v-primary-base) !important;
}
.v-tab--active{
  color:initial;
}
.v-tab--active > .v-chip{
  background-color: var(--v-primary-base) !important;
  color: #F5F5F5 !important;
}
#tab{
  max-width:unset;
}
#tab.active{
  font-size: 10rem;
}
#chip{
  margin-left: 10px;
}
#datatable{
  position: inherit !important;
}
</style>